@if (!isLoading) {
  <div
    class="component-container"
    [ngStyle]="{
      '--color50': seminarCategory?.color50 ?? seminar?.category1?.color50,
      '--color0': seminarCategory?.color0 ?? seminar?.category1?.color0,
      '--color70': seminarCategory?.color70 ?? seminar?.category1?.color70,
      '--color80': seminarCategory?.color80 ?? seminar?.category1?.color80,
      '--color90': seminarCategory?.color90 ?? seminar?.category1?.color90,
    }">
    <div class="page-navigation">
      <div class="circle-large" (click)="onGoBack()">
        <div class="circle-icon">
          <i class="fa-regular fa-arrow-left fa-xl"></i>
        </div>
      </div>
    </div>
    @if (freeSeats() <= 0 && !isOnWaitlist()) {
      <div class="snackbar-with-icon snackbar-red">
        <i class="fa-regular fa-calendar-clock"></i>
        <span>
          Dieser Kurs ist ausgebucht. Du kannst dich jedoch auf die Warteliste
          setzen lassen. Falls ein Teilnehmer seine Teilnahme absagt, wirst du
          kontaktiert und kannst dich dann für den Kurs anmelden.
        </span>
      </div>
    }
    @if (freeSeats() <= 0 && isOnWaitlist()) {
      <div class="snackbar-with-icon snackbar-yellow">
        <i class="fa-regular fa-calendar-clock"></i>
        <span>
          Du bist erfolgreich in die Warteliste für dieses Seminar eingetragen.
          Sobald mindestens ein Platz frei wird, kannst du den Buchungsprozess
          abschließen.
        </span>
      </div>
    }
    @if (freeSeats() > 0 && isOnWaitlist()) {
      <div class="snackbar-with-icon snackbar-green">
        <i class="fa-regular fa-calendar"></i>
        <span>
          Es gibt {{ freeSeats() }} freie Plätze in diesem Seminar, damit du
          dich anmelden kannst.
        </span>
      </div>
    }
    @if (currentScreen === 'registration') {
      <div class="main-content">
        <div class="course-title background-transparent">
          <span class="font-bold-display-medium">
            {{ isOnWaitlist() ? 'Warteliste' : 'Anmeldeformular' }}
          </span>
          <span class="font-regular-title-large font-color-black">
            {{ seminar.title }}
          </span>
        </div>
        <form class="formular-container" [formGroup]="seminarRegistrationForm">
          <div
            class="course-choice background-transparent"
            [class.invalid]="
              seminarRegistrationForm.get('dateSeriesChoice').invalid &&
              seminarRegistrationForm.get('dateSeriesChoice').touched
            ">
            <div class="flex-c align-start gap-16 align-self-stretch">
              <div
                class="display-flex align-center gap-8 align-self-stretch title">
                <div class="w-h-44 flex-c align-center justify-center">
                  <i class="fa-regular fa-book-bookmark fa-2x"></i>
                </div>
                <span class="font-medium-title-large">
                  Auswahl der Seminare
                </span>
              </div>
              <div
                class="flex-c align-start gap-24 align-self-stretch font-color-black">
                @for (dateSeries of seminar.dateSeries; track dateSeries.id) {
                  <div class="flex-r align-center gap-4 align-self-stretch">
                    <div class="inwi-radio">
                      <input
                        [id]="dateSeries.id"
                        type="radio"
                        name="dateSeriesChoice"
                        [value]="dateSeries.id"
                        formControlName="dateSeriesChoice" />
                    </div>
                    <label
                      [for]="dateSeries.id"
                      class="flex-c align-start gap-4 flex-1-0-0">
                      <span class="font-medium-title-medium">
                        {{ dateSeries.name }}
                      </span>
                      @for (date of dateSeries.dates; track date.id) {
                        <span class="font-regular-body-large">
                          Teil {{ $index + 1 }}:
                          {{ date.startDate | date: 'dd. MMMM HH:mm' }} -
                          {{ date.endDate | date: 'HH:mm' }}
                        </span>
                      }
                    </label>
                    <div>
                      <div
                        [class]="
                          getParticipantsLoadClass(
                            seminar.maxParticipants,
                            dateSeries.participantCount
                          )
                        ">
                        {{ freeSeatsText(dateSeries) }}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
          <div
            class="flex-c gap-24 align-self-stretch"
            formArrayName="participants">
            @for (
              participantControls of participants.controls;
              let idx = $index;
              track $index
            ) {
              <div
                class="participant-data background-transparent"
                [formGroupName]="idx">
                <div class="flex-c align-start gap-24 align-self-stretch">
                  <div
                    class="flex-r gap-8 align-self-stretch justify-space-between">
                    <div
                      class="display-flex align-center gap-8 align-self-stretch title">
                      <div class="w-h-44 flex-c align-center justify-center">
                        <i class="fa-regular fa-user fa-2x"></i>
                      </div>
                      <span class="font-medium-title-large">
                        Teilnehmer {{ idx + 1 }}
                      </span>
                    </div>
                    @if (idx > 0) {
                      <button
                        type="button"
                        class="inwi-icon-text-button-medium-secondary"
                        (click)="removeParticipant(idx)">
                        <div class="button-content">
                          <i class="fa-regular fa-user-minus button-icon"></i>
                          <div class="button-text">Entfernen</div>
                        </div>
                      </button>
                    }
                  </div>
                  <div class="flex-c align-start gap-16 align-self-stretch">
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantSalutation">
                          Anrede{{
                            fieldRequired(participantControls.get('salutation'))
                              ? '*'
                              : ''
                          }}
                        </div>

                        <p-select
                          id="participantSalutation"
                          formControlName="salutation"
                          [options]="salutationOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Anrede auswählen..." />
                        <app-error-message
                          [formField]="
                            participantControls.get('salutation')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantJobTitle">
                          Beruf{{
                            fieldRequired(participantControls.get('jobTitle'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="jobTitle"
                          name="participantJobTitle"
                          type="text"
                          placeholder="Beruf" />
                        <app-error-message
                          [formField]="
                            participantControls.get('jobTitle')
                          "></app-error-message>
                      </div>
                    </div>
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantFirstName">
                          Vorname{{
                            fieldRequired(participantControls.get('firstName'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="firstName"
                          name="participantFirstName"
                          type="text"
                          placeholder="Vorname" />
                        <app-error-message
                          [formField]="
                            participantControls.get('firstName')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantLastName">
                          Nachname{{
                            fieldRequired(participantControls.get('lastName'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="lastName"
                          name="participantLastName"
                          type="text"
                          placeholder="Nachname" />
                        <app-error-message
                          [formField]="
                            participantControls.get('lastName')
                          "></app-error-message>
                      </div>
                    </div>
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantStreet">
                          Straße{{
                            fieldRequired(participantControls.get('street'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="street"
                          name="participantStreet"
                          type="text"
                          placeholder="Straße" />
                        <app-error-message
                          [formField]="
                            participantControls.get('street')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantStreetNr">
                          Hausnummer{{
                            fieldRequired(participantControls.get('streetNr'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="streetNr"
                          name="participantStreetNr"
                          type="text"
                          placeholder="Hausnummer" />
                        <app-error-message
                          [formField]="
                            participantControls.get('streetNr')
                          "></app-error-message>
                      </div>
                    </div>
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantZip">
                          PLZ{{
                            fieldRequired(participantControls.get('zip'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="zip"
                          name="participantZip"
                          type="text"
                          placeholder="PLZ" />
                        <app-error-message
                          [formField]="
                            participantControls.get('zip')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantCity">
                          Ort{{
                            fieldRequired(participantControls.get('city'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="city"
                          name="participantCity"
                          type="text"
                          placeholder="Ort" />
                        <app-error-message
                          [formField]="
                            participantControls.get('city')
                          "></app-error-message>
                      </div>
                    </div>
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantCountry">
                          Land{{
                            fieldRequired(participantControls.get('country'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <p-select
                          id="participantCountry"
                          formControlName="country"
                          [options]="countryOptions"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Land auswählen..." />
                        <app-error-message
                          [formField]="
                            participantControls.get('country')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantBirthdate">
                          Geburtsdatum{{
                            fieldRequired(participantControls.get('birthdate'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <p-datepicker
                          appendTo="body"
                          inputId="birthdate"
                          name="participantBirthdate"
                          class="align-self-stretch"
                          formControlName="birthdate"
                          dateFormat="dd.mm.yy"
                          [maxDate]="maxDateBirthdate"
                          [minDate]="minDateBirthdate"
                          [defaultDate]="defaultDateBirthdate"
                          placeholder="TT.MM.JJJJ" />
                        <app-error-message
                          [formField]="
                            participantControls.get('birthdate')
                          "></app-error-message>
                      </div>
                    </div>
                    <div class="formular-row-2-inputs">
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="participantEmail">
                          E-Mail{{
                            fieldRequired(participantControls.get('email'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          id="participantEmail"
                          class="input-field"
                          formControlName="email"
                          name="participantEmail"
                          type="text"
                          placeholder="E-Mail" />
                        <app-error-message
                          [formField]="
                            participantControls.get('email')
                          "></app-error-message>
                      </div>
                      <div class="input-simple flex-1-0-0">
                        <div class="input-label" for="particpantPhone">
                          Telefon{{
                            fieldRequired(participantControls.get('phone'))
                              ? '*'
                              : ''
                          }}
                        </div>
                        <input
                          class="input-field"
                          formControlName="phone"
                          name="particpantPhone"
                          type="text"
                          placeholder="Telefon" />
                        <app-error-message
                          [formField]="
                            participantControls.get('phone')
                          "></app-error-message>
                      </div>
                    </div>
                    <div
                      class="display-flex align-start gap-24 align-self-stretch">
                      <div class="input-simple flex-1-0-0">
                        <div
                          class="input-label justify-space-between"
                          for="questions">
                          Fragen vorab/besonderes Interesse{{
                            fieldRequired(participantControls.get('questions'))
                              ? '*'
                              : ''
                          }}
                          <div class="input-label-hint">
                            {{
                              getTextAreaLength(
                                participantControls.get('questions')
                              )
                            }}
                            /
                            {{
                              getMaxLengthFromValidator(
                                participantControls.get('questions')
                              )
                            }}
                          </div>
                        </div>
                        <textarea
                          class="input-textarea"
                          formControlName="questions"
                          name="questions"
                          type="text"
                          rows="5"
                          [placeholder]="
                            seminar.specialInterest ??
                            'Interessiert Dich ein Teilbereich/Aspekt besonders? Hast Du eine spezifische Frage zum Thema an den/die Dozierende?'
                          ">
                        </textarea>
                        <app-error-message
                          [formField]="
                            participantControls.get('questions')
                          "></app-error-message>
                      </div>
                    </div>
                  </div>
                  <mat-divider class="align-self-stretch"></mat-divider>
                  <div class="flex-c align-start gap-16 align-self-stretch">
                    <div
                      class="display-flex align-center gap-8 align-self-stretch title">
                      <span class="font-medium-title-large">
                        Teilnehmertyp
                      </span>
                    </div>
                    <div
                      class="display-flex align-start gap-24 align-self-stretch">
                      <div class="align-start gap-16 formular-row-2-inputs">
                        <div
                          class="flex-c align-start align-self-stretch flex-1-0-0 font-color-black"
                          [class.invalid]="
                            participantControls.get('condition').invalid &&
                            participantControls.get('condition').touched
                          ">
                          @for (condition of seminar.conditions; track $index) {
                            <div
                              class="flex-r align-center gap-4 align-self-stretch">
                              <div class="inwi-radio flex-1-1-0">
                                <input
                                  id="price{{ condition.type }} + {{ idx }}"
                                  type="radio"
                                  [value]="condition.type"
                                  [attr.disabled]="
                                    conditionDisabled(condition)
                                      ? 'disabled'
                                      : null
                                  "
                                  (change)="
                                    onConditionSelected(idx, condition.type)
                                  "
                                  formControlName="condition" />
                                <label
                                  for="price{{ condition.type }} + {{ idx }}"
                                  class="font-regular-body-large flex-1-1-0">
                                  {{
                                    condition.type === SeminarConditionType.VDP
                                      ? 'VDP Mitglied'
                                      : condition.type ===
                                          SeminarConditionType.VDB
                                        ? 'VDB Mitglied'
                                        : condition.type ===
                                          SeminarConditionType.EARLY
                                        ? 'Frühbucher'
                                        : condition.type ===
                                            SeminarConditionType.BED
                                          ? 'BED Mitglied'
                                          : condition.type ===
                                              SeminarConditionType.OFFICE
                                            ? 'Praxis (ab 3 Personen)'
                                            : condition.type ===
                                                SeminarConditionType.LOGO
                                              ? 'LOGO Deutschland Mitglied'
                                              : 'Regulär'
                                  }}{{
                                    condition.date
                                      ? '(bei Buchung bis ' +
                                        (condition.date | date: 'dd.MM.yyyy') +
                                        ')'
                                      : ''
                                  }}
                                </label>
                              </div>
                              <div class="flex-r align-start gap-4 flex-1-1-0">
                                <span class="font-bold-body-large">
                                  {{ condition.price | currency: 'EUR' }}
                                </span>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="input-simple flex-1-0-0 align-self-start">
                          @if (
                            participantControls.get('condition')?.value ===
                              SeminarConditionType.LOGO ||
                            participantControls.get('condition')?.value ===
                              SeminarConditionType.VDB ||
                            participantControls.get('condition')?.value ===
                              SeminarConditionType.VDP ||
                            participantControls.get('condition')?.value ===
                              SeminarConditionType.BED
                          ) {
                            <div class="input-label" for="password">
                              @if (
                                participantControls.get('condition')?.value ===
                                SeminarConditionType.LOGO
                              ) {
                                LOGO Deutschland Passwort
                              } @else if (
                                participantControls.get('condition')?.value ===
                                SeminarConditionType.VDB
                              ) {
                                VDB Passwort
                              } @else if (
                                participantControls.get('condition')?.value ===
                                SeminarConditionType.VDP
                              ) {
                                VDP Passwort
                              } @else if (
                                participantControls.get('condition')?.value ===
                                SeminarConditionType.BED
                              ) {
                                BED Mitgliedsnummer
                              }
                              {{
                                fieldRequired(
                                  participantControls.get('password')
                                )
                                  ? '*'
                                  : ''
                              }}
                            </div>
                            <input
                              id="participantPassword"
                              class="input-field"
                              formControlName="password"
                              name="participantPassword"
                              type="text"
                              placeholder="{{
                                participantControls.get('condition')?.value ===
                                SeminarConditionType.BED
                                  ? 'AD23456'
                                  : 'Passwort'
                              }}" />
                            <app-error-message
                              [formField]="
                                participantControls.get('password')
                              "></app-error-message>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <span
                      class="font-regular-body-large"
                      style="color: var(--neutral-10, #807b78)">
                      * Pflichtfelder sind mit einem Sternchen gekennzeichnet.
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="flex-r align-self-stretch justify-end padding-32-0">
            <button
              type="button"
              class="inwi-icon-text-button-large-outline"
              (click)="addParticipant()">
              <div class="button-content">
                <div class="button-icon">
                  <i class="fa-regular fa-user-plus"></i>
                </div>
                <div class="button-text">Weiteren Teilnehmer hinzufügen</div>
              </div>
            </button>
          </div>
          <div class="total-amount background-transparent">
            <div
              class="display-flex align-center gap-8 align-self-stretch title">
              <div class="w-h-44 flex-c align-center justify-center">
                <i class="fa-regular fa-euro-sign fa-2x"></i>
              </div>
              <span class="font-medium-title-large"> Gesamtbetrag </span>
              <div class="flex-1-0-0"></div>
              <span class="font-medium-title-large font-color-black">
                {{ calculatePrice() | currency: 'EUR' }}
              </span>
            </div>
            <div class="flex-c align-start gap-16 align-self-stretch">
              @for (coupon of validCoupons; track $index) {
                <div
                  class="flex-r justify-space-between align-self-stretch align-center">
                  <div class="inwi-chip-text-green-outline gap-8">
                    <span>Coupon: {{ coupon.code }}</span>
                    <button
                      type="button"
                      class="coupon-remove-button"
                      (click)="removeCoupon($index)">
                      <i class="fa-regular fa-times icon-24"></i>
                    </button>
                  </div>
                  <span class="font-regular-title-medium">
                    @if (coupon.discountType === 'percentage') {
                      -{{
                        calculatePrice() * (coupon.value / 100)
                          | currency: 'EUR'
                      }}
                      ({{ coupon.value | number: '1.0-0' }}%)
                    } @else {
                      -{{ coupon.value | currency: 'EUR' }}
                    }
                  </span>
                </div>
              }
              @if (
                calculateDiscountedPrice(true) < 0 && priceSelectionValid()
              ) {
                <div class="inwi-text-error">
                  Nach erfolgreicher Anmeldung wird dir ein Gutschein im Wert
                  von
                  {{ calculateDiscountedPrice(true) * -1 | currency: 'EUR' }}
                  ausgestellt.
                </div>
              }
              @if (validCoupons && validCoupons.length > 0) {
                <div (click)="showCouponInput = true" class="cursor-pointer">
                  <u class="font-regular-body-large">
                    Hast du andere Gutscheine?
                  </u>
                </div>
              }
              @if (showCouponInput) {
                <div class="input-simple coupon-input">
                  <div class="input-label" for="couponCode">
                    Hast Du einen Gutschein?{{
                      fieldRequired(seminarRegistrationForm.get('couponCode'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    class="input-field uppercase"
                    formControlName="couponCode"
                    (keydown)="onCouponCodeKeyPress($event)"
                    name="couponCode"
                    type="text"
                    placeholder="Gutscheincode eingeben" />
                </div>
                <app-error-message
                  [formField]="
                    seminarRegistrationForm.get('couponCode')
                  "></app-error-message>
              }
            </div>
            <div class="discounted-total font-bold-title-large">
              Total: {{ calculateDiscountedPrice() | currency: 'EUR' }}
            </div>
          </div>
          <div class="total-amount background-transparent">
            <div
              class="display-flex align-center gap-8 align-self-stretch title cursor-pointer"
              (click)="toggleBillingAddress = !toggleBillingAddress">
              <div class="w-h-44 flex-c align-center justify-center">
                <i class="fa-regular fa-receipt fa-2x"></i>
              </div>
              <span class="font-medium-title-large"> Rechnungsanschrift </span>
              <div class="flex-1-0-0"></div>
              <button
                type="button"
                class="circle-medium border-none font-color-black">
                <div class="circle-icon">
                  <i
                    class="fa-regular fa-xl"
                    [class]="
                      toggleBillingAddress ? 'fa-chevron-up' : 'fa-chevron-down'
                    "></i>
                </div>
              </button>
            </div>
            @if (toggleBillingAddress) {
              <span class="font-regular-body-large font-color-black">
                Diese Informationen sind wichtig, um die Rechnung zu erstellen
                und dich im Falle von Rückfragen bezüglich der Kursanmeldung zu
                kontaktieren.
              </span>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="billingFacility">
                    Einrichtung{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingFacility')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    class="input-field"
                    formControlName="billingFacility"
                    name="billingFacility"
                    type="text"
                    placeholder="Einrichtung" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingFacility')
                    "></app-error-message>
                </div>
                <div class="flex-1-0-0 placeholder"></div>
              </div>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="firstName">
                    Vorname{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingFirstName')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="firstName"
                    class="input-field"
                    formControlName="billingFirstName"
                    name="firstName"
                    type="text"
                    autocomplete="given-name"
                    placeholder="Vorname" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingFirstName')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="lastName">
                    Nachname{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingLastName')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="lastName"
                    class="input-field"
                    formControlName="billingLastName"
                    name="lastName"
                    type="text"
                    autocomplete="family-name"
                    placeholder="Nachname" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingLastName')
                    "></app-error-message>
                </div>
              </div>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="street">
                    Straße{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingStreet')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="street"
                    class="input-field"
                    formControlName="billingStreet"
                    name="street"
                    type="text"
                    autocomplete="street-address"
                    placeholder="Straße" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingStreet')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="billingStreetNr">
                    Hausnummer{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingStreetNr')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    class="input-field"
                    formControlName="billingStreetNr"
                    name="billingStreetNr"
                    type="text"
                    placeholder="Hausnummer" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingStreetNr')
                    "></app-error-message>
                </div>
              </div>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="zip">
                    PLZ{{
                      fieldRequired(seminarRegistrationForm.get('billingZip'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="zip"
                    class="input-field"
                    formControlName="billingZip"
                    name="zip"
                    type="text"
                    autocomplete="postal-code"
                    placeholder="PLZ" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingZip')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="city">
                    Ort{{
                      fieldRequired(seminarRegistrationForm.get('billingCity'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="city"
                    class="input-field"
                    formControlName="billingCity"
                    name="city"
                    type="text"
                    autocomplete="address-level1"
                    placeholder="Ort" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingCity')
                    "></app-error-message>
                </div>
              </div>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="billingCountry">
                    Land{{
                      fieldRequired(
                        seminarRegistrationForm.get('billingCountry')
                      )
                        ? '*'
                        : ''
                    }}
                  </div>
                  <p-select
                    id="billingCountry"
                    formControlName="billingCountry"
                    [options]="countryOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Land auswählen..." />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingCountry')
                    "></app-error-message>
                </div>
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="email">
                    E-Mail{{
                      fieldRequired(seminarRegistrationForm.get('billingEmail'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="email"
                    class="input-field"
                    formControlName="billingEmail"
                    name="email"
                    type="text"
                    autocomplete="email"
                    placeholder="E-Mail" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingEmail')
                    "></app-error-message>
                </div>
              </div>
              <div class="formular-row-2-inputs">
                <div class="input-simple flex-1-0-0">
                  <div class="input-label" for="phone">
                    Telefon{{
                      fieldRequired(seminarRegistrationForm.get('billingPhone'))
                        ? '*'
                        : ''
                    }}
                  </div>
                  <input
                    id="phone"
                    class="input-field"
                    formControlName="billingPhone"
                    name="phone"
                    type="text"
                    autocomplete="tel"
                    placeholder="Telefon" />
                  <app-error-message
                    [formField]="
                      seminarRegistrationForm.get('billingPhone')
                    "></app-error-message>
                </div>
                <div class="flex-1-0-0 placeholder"></div>
              </div>
              <div>
                <span
                  class="font-regular-body-large"
                  style="color: var(--neutral-10, #807b78)">
                  * Pflichtfelder sind mit einem Sternchen gekennzeichnet.
                </span>
              </div>
            }
          </div>
          <div class="checkboxen">
            <div class="flex-c align-self-stretch">
              <div
                class="flex-r align-center gap-4 align-self-stretch"
                [class.invalid-checkbox]="
                  seminarRegistrationForm.get('termsOfParticipation').invalid &&
                  seminarRegistrationForm.get('termsOfParticipation').touched
                ">
                <div class="inwi-checkbox">
                  <input
                    id="termsOfParticipation"
                    type="checkbox"
                    name="termsOfParticipation"
                    formControlName="termsOfParticipation" />
                </div>
                <div class="flex-c align-start gap-4 flex-1-0-0">
                  <label
                    for="termsOfParticipation"
                    class="font-regular-body-large">
                    Hiermit bestätige ich meine Kenntnisnahme und Akzeptanz der
                    <a
                      href="/agb"
                      target="_blank"
                      class="font-regular-body-large font-color-black">
                      AGB
                    </a>
                    und der
                    <a
                      href="/teilnahmebedingungen"
                      target="_blank"
                      class="font-regular-body-large font-color-black">
                      Teilnahmebedingungen </a
                    >.
                  </label>
                </div>
              </div>
              @if (
                seminarRegistrationForm.get('termsOfParticipation').invalid &&
                seminarRegistrationForm.get('termsOfParticipation').touched
              ) {
                <div class="inwi-error-container">
                  <div class="inwi-text-error font-regular-label-large">
                    Sie müssen die AGB akzeptieren.
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
        <div class="formular-buttons">
          <button
            type="button"
            class="inwi-icon-text-button-large-secondary"
            (click)="onGoBack()">
            <div class="button-content">
              <div class="button-icon">
                <i class="fa-regular fa-xmark"></i>
              </div>
              <div class="button-text">Abbrechen</div>
            </div>
          </button>
          @if (freeSeats() - participants.length < 0) {
            <button
              type="submit"
              class="inwi-icon-text-button-large-primary"
              (click)="onBookWaitlist()">
              <div class="button-content">
                <div class="button-icon">
                  <i class="fa-regular fa-calendar-clock"></i>
                </div>
                <div class="button-text">Wartelistenplatz buchen</div>
              </div>
            </button>
          } @else {
            <button
              type="submit"
              class="inwi-icon-text-button-large-primary"
              (click)="onSubmit()">
              <div class="button-content">
                <div class="button-icon">
                  <i class="fa-regular fa-calendar"></i>
                </div>
                <div class="button-text">Jetzt Anmelden</div>
              </div>
            </button>
          }
        </div>
      </div>
    } @else if (currentScreen === 'registrationSummary') {
      <app-booking-details
        class="padding-bottom-48"
        [booking]="booking"
        [seminarCategory]="seminarCategory"
        [bookingSummary]="true"></app-booking-details>
    } @else if (currentScreen === 'paymentMethod') {
      <app-choose-payment-method
        [bookingCreateModel]="bookingCreateModel"
        [totalAmount]="calculatePrice()"
        [category]="seminarCategory"
        (bookingIdSet)="bookingId = $event"
        [paypalEnabled]="paypalEnabled && booking.discountedPrice > 0"
        (paymentMethodSelected)="
          onPaymentMethodSelected($event)
        "></app-choose-payment-method>
    } @else if (currentScreen === 'paymentDetails') {
      <app-payment-details
        class="padding-bottom-48"
        [category]="seminarCategory"
        [totalAmount]="calculateDiscountedPrice()"></app-payment-details>
    }
  </div>
  @if (currentScreen === 'registrationSummary') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onGoBack()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      @if (calculateDiscountedPrice() === 0) {
        <button
          type="submit"
          class="inwi-icon-text-button-large-primary"
          (click)="onCompleteOrder(true)">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-credit-card"></i>
            </div>
            <div class="button-text">Jetzt buchen</div>
          </div>
        </button>
      } @else {
        <button
          type="submit"
          class="inwi-icon-text-button-large-primary"
          (click)="onGoToCheckout()">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-credit-card"></i>
            </div>
            <div class="button-text">Zur Kasse gehen</div>
          </div>
        </button>
      }
    </div>
  } @else if (currentScreen === 'paymentDetails') {
    <div class="sticky-container-bottom">
      <button
        type="button"
        class="inwi-icon-text-button-large-secondary"
        (click)="onGoBack()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      <button
        type="submit"
        class="inwi-icon-text-button-large-primary"
        (click)="onCompleteOrder()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-euro-sign"></i>
          </div>
          <div class="button-text">Kostenpfichtig buchen</div>
        </div>
      </button>
    </div>
  }
} @else {
  <div class="main-container">
    <div class="main-content">
      <div class="loading-wrapper">
        <mat-progress-spinner
          color="primary"
          mode="indeterminate"
          diameter="100">
        </mat-progress-spinner>
      </div>
    </div>
  </div>
}
